import {
  type TripContext,
  type WatchAlertView,
  WatchAlertViewsResponse,
  WatchAlertViewsSuccess,
} from "@b2bportal/air-price-watch-api";
import { createTrackingEmitterHooks } from "@b2bportal/core-tracking";

export type AirPriceWatchRawEvent =
  | AirPriceWatchesLoadedEvent
  | AirPriceWatchRemovedEvent
  | AirPriceWatchAddedEvent
  | AirPriceWatchExpiredEvent
  | AirPriceWatchTappedEvent
  | AirPriceWatchesViewedEvent;

export enum AirPriceWatchRawEventName {
  AirPriceWatchesLoaded = "AirPriceWatchesLoaded",
  AirPriceWatchRemoved = "AirPriceWatchRemoved",
  AirPriceWatchAdded = "AirPriceWatchAdded",
  AirPriceWatchExpired = "AirPriceWatchExpired",
  AirPriceWatchTapped = "AirPriceWatchTapped",
  AirPriceWatchesViewed = "AirPriceWatchesViewed",
}

export type AirPriceWatchesLoadedEvent = {
  name: AirPriceWatchRawEventName.AirPriceWatchesLoaded;
  properties: { active_watches: number };
};

export type AirPriceWatchRemovedEvent = {
  name: AirPriceWatchRawEventName.AirPriceWatchRemoved;
};

export type AirPriceWatchAddedEvent = {
  name: AirPriceWatchRawEventName.AirPriceWatchAdded;
};

export type AirPriceWatchExpiredEvent = {
  name: AirPriceWatchRawEventName.AirPriceWatchExpired;
};

export type AirPriceWatchTappedEvent = {
  name: AirPriceWatchRawEventName.AirPriceWatchTapped;
  properties: { watch: WatchAlertView; tripContext: TripContext };
};

export type AirPriceWatchesViewedEvent = {
  name: AirPriceWatchRawEventName.AirPriceWatchesViewed;
  properties: { active_watches: number };
};

export const {
  useEmitRawEvent: useEmitCoreAirPriceWatchEvent,
  useEmitRawEventOnce: useEmitCoreAirPriceWatchEventOnce,
  useEmitBeforeLoad: useEmitCoreAirPriceWatchBeforeLoad,
} = createTrackingEmitterHooks<AirPriceWatchRawEvent>();
